{
  "navigation.group.myViews": "我的视图",
  "navigation.group.analytics": "运营与分析",
  "navigation.group.system": "系统",
  "navigation.item.overview": "概览",
  "navigation.item.customers": "客户资料",
  "navigation.item.reports": "报表分析",
  "navigation.item.notifications": "通知中心",
  "navigation.item.systemConfiguration": "系统配置",
  "navigation.item.projects": "项目",
  "navigation.item.categories": "工单分类",
  "navigation.item.routingRules": "路由规则",
  "navigation.item.organization": "客服组和成员",
  "navigation.item.ai": "AI 智能",
  "navigation.item.systemSettings": "系统设置",
  "ticketView.all.label": "全部工单",
  "ticketView.all.title": "全部工单",
  "ticketView.all.description": "集中查看、筛选和处理所有客户工单。",
  "ticketView.assigned.label": "分配给我",
  "ticketView.assigned.title": "分配给我",
  "ticketView.assigned.description": "查看当前由我跟进的工单。",
  "ticketView.unassigned.label": "待分配",
  "ticketView.unassigned.title": "待分配工单",
  "ticketView.unassigned.description": "查看已进入客服组但尚未指定跟进人的工单，可进行认领或人工指派。",
  "ticketView.participating.label": "参与中的",
  "ticketView.participating.title": "参与中的工单",
  "ticketView.participating.description": "查看我作为协作者参与处理的工单。",
  "ticketView.uncategorized.label": "待分类",
  "ticketView.uncategorized.title": "待分类",
  "ticketView.uncategorized.description": "集中处理还没有分类的工单；已关闭与已取消的不可再改分类，不进队列。",
  "ticketView.recentlyResolved.label": "最近解决",
  "ticketView.recentlyResolved.title": "最近解决",
  "ticketView.recentlyResolved.description": "按解决时间查看最近完成处理的工单。",
  "shell.workspaceNavigation": "工作台导航",
  "shell.systemNavigation": "系统配置导航",
  "shell.expandSidebar": "展开侧边栏",
  "shell.collapseSidebar": "收起侧边栏",
  "shell.closeSidebar": "关闭侧边栏",
  "shell.openNavigation": "打开导航",
  "shell.searchAndCommands": "搜索与命令",
  "shell.openSearchAndCommands": "打开搜索与命令",
  "shell.commandPalette.title": "搜索与命令",
  "shell.commandPalette.description": "打开页面，或输入内容开始搜索。",
  "shell.commandPalette.placeholder": "搜索或输入命令…",
  "shell.commandPalette.empty": "没有可用的页面或搜索范围。",
  "shell.commandPalette.current": "当前",
  "shell.commandPalette.searchFor": "搜索“{query}”的范围",
  "shell.commandPalette.scope.all": "整个工作台",
  "shell.commandPalette.scope.tickets": "工单",
  "shell.commandPalette.scope.customers": "客户",
  "shell.commandPalette.scope.agents": "成员",
  "search.title": "搜索",
  "search.description": "在工作台中查找工单、客户和成员。",
  "search.descriptionWithQuery": "搜索词：“{query}”",
  "search.scope.all": "全部",
  "search.scope.tickets": "工单",
  "search.scope.customers": "客户",
  "search.scope.agents": "成员",
  "search.results.title": "搜索结果",
  "search.results.description": "“{scope}”范围的结果将在这里显示。",
  "search.noQuery.title": "请输入搜索内容",
  "search.noQuery.description": "使用顶部的搜索入口开始搜索。",
  "shell.dismissTask": "收起任务状态",
  "shell.dismissOperation": "收起操作结果",
  "shell.taskRunning": "任务进行中",
  "shell.taskProgress": "任务进度：{progress}%",
  "shell.mainNavigation": "主导航",
  "shell.returnWorkspace": "返回工作台",
  "shell.systemConfiguration": "系统配置"
}
